import { isEmpty } from 'lodash';
import { makeStyles } from 'tss-react/mui';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { useSelector, useInstanceSelector } from '@client/hooks/redux.hooks';
import { getCurrentShow, getProductsForShow } from '@client/selectors/entities/shows';
import { inProgress } from '@client/selectors/helpers/loaders';
import { PaddedDivider } from '@client/components/common/PaddedDivider';
import { useTicketingCheck } from '@client/hooks/useTicketingCheck';

const useStyles = makeStyles()((theme) => ({
  mobileSoldOutWrapper: {
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4),
    },
  },
}));

export const CannotPurchaseTicket = () => {
  const { classes } = useStyles();

  const { id: showId, isCancelled, isIncomplete } = useSelector(getCurrentShow);
  const [badge, canPurchaseTickets] = useTicketingCheck({ showId });

  const scope = `fetch-${showId}-SKU`;
  const stripeLoaderInProgress = useInstanceSelector(inProgress, scope);

  const products = useSelector(getProductsForShow);

  if (canPurchaseTickets) {
    return null;
  }

  if ((stripeLoaderInProgress !== false || isEmpty(products)) && !isCancelled && !isIncomplete) {
    return (
      <>
        <br />

        <Grid
          alignItems="center"
          container
          justifyContent="flex-start"
          spacing={3}
        >
          <Grid item>
            <CircularProgress />
          </Grid>

          <Grid item>
            <Typography>
              Loading ticket information...
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <div className={classes.mobileSoldOutWrapper}>
      <Typography
        variant="body2"
        gutterBottom
      >
        {badge.long}
      </Typography>

      <PaddedDivider />
    </div>
  );
};
